import { HStack, List, Text, useDisclosure } from '@chakra-ui/react';
import { BaseButton, BaseDialog } from '@invara-dev/react-base';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import { useCurrentAnnouncementQuery } from './useCurrentAnnouncmentQuery';

export const AnnouncementBox = () => {
  const announcement = useCurrentAnnouncementQuery();
  const announcementDisclosure = useDisclosure();

  if (announcement.isLoading || !announcement.data) {
    return null;
  }

  return (
    <HStack
      overflow={'clip'}
      color={'white'}
      backgroundColor={'secondary.500'}
      w={'100%'}
      p={'4px'}
      justifyContent={'space-evenly'}
      //pos={'absolute'}
      fontSize={'10px'}
      fontWeight={'bold'}
      bottom={0}>
      {announcement.data.Notes.split('\n').map((r, i) => (
        <Text key={`${i}-AnnouncementBox`}>{r}</Text>
      ))}
      <BaseButton
        pos={'absolute'}
        left={0}
        color={'white'}
        variant={'plain'}
        h={'fit-content'}
        w={'fit-content'}
        fontSize={'10px'}
        icon={faExpand}
        onClick={announcementDisclosure.onOpen}
      />
      <BaseDialog disclosure={announcementDisclosure} dragDialog={{}} header='Announcements'>
        <List.Root gap={'4px'} listStyle={'none'}>
          {announcement.data.Notes.split('\n').flatMap((r, i) => {
            if (r.trim().length == 0) {
              return [];
            }
            return (
              <List.Item key={`${i}-AnnouncementBoxFloat`} p={'4px'} color={'white'} backgroundColor={'secondary.500'}>
                <Text>{r}</Text>
              </List.Item>
            );
          })}
        </List.Root>
      </BaseDialog>
    </HStack>
  );
};
